import { useDispatch, useSelector } from "react-redux";
import { customNotification } from "DesignSystem/Notifications/Notification";
import { WebService } from "services/web/webService";
import {
  fetchAllNovaConversationsRequest,
  fetchAllNovaConversationsSuccess,
  fetchAllNovaConversationsFailure,
  sendNovaChatFeedbackRequest,
  sendNovaChatFeedbackSuccess,
  sendNovaChatFeedbackFailure,
  getUpdatedConversationRequest,
  getUpdatedConversationSuccess,
  getUpdatedConversationFailure,
  updateConversationTitleSuccess,
  setChangedConversation,
} from "store/AiFeatures/GoalsCreateWithNovaAI/action";
import { getNovaConversationId } from "utils/getNovaConversationDetails";

const useNovaApi = () => {
  const dispatch = useDispatch();
  const accountId = useSelector((state) => state?.user?.accountId);
  const conversationId = useSelector(getNovaConversationId);
  const renameConversation = async (newTitle) => {
    try {
      const response = await WebService.put(
        `accounts/${accountId}/nova_conversations/${conversationId}`,
        {
          nova_conversation: { name: newTitle },
        }
      );

      const updated = response?.data?.success;
      if (updated?.name) {
        dispatch(updateConversationTitleSuccess(updated.id, updated.name));
        dispatch(setChangedConversation(true, updated.id, updated.name));
        customNotification("success", "Conversation Title Updated");
      }
    } catch (err) {
      customNotification("error", "Failed to rename conversation");
      console.error("Failed to rename conversation", err);
    }
  };

  const fetchAllConversations = async ({ page = 1, limit = 10 } = {}) => {
    try {
      dispatch(fetchAllNovaConversationsRequest());

      const response = await WebService.get(
        `accounts/${accountId}/nova_conversations?page=${page}&limit=${limit}`
      );

      const data = response?.data?.success;

      if (data) {
        dispatch(fetchAllNovaConversationsSuccess(data));
      } else {
        throw new Error("Invalid response format");
      }
    } catch (error) {
      console.error("Error fetching all conversations:", error);
      dispatch(
        fetchAllNovaConversationsFailure(error.message || "Fetch failed")
      );
    }
  };

  const sendNovaChatFeedback = async ({
    conversationId,
    messageId,
    feedback,
  }) => {
    try {
      dispatch(sendNovaChatFeedbackRequest());

      const response = await WebService.post(
        `accounts/${accountId}/nova_conversations/${conversationId}/nova_chat_messages/${messageId}/nova_feedback`,
        {
          conversationId,
          messageId,
          nova_feedback: feedback,
        }
      );

      dispatch(sendNovaChatFeedbackSuccess(response?.data?.success));
    } catch (error) {
      console.error("Error sending feedback", error);
      dispatch(sendNovaChatFeedbackFailure(error.message || "Unknown error"));
    }
  };

  const getUpdatedConversation = async (conversationId) => {
    try {
      dispatch(getUpdatedConversationRequest());

      const response = await WebService.get(
        `accounts/${accountId}/nova_conversations/${conversationId}`
      );

      dispatch(getUpdatedConversationSuccess(response?.data?.success));
    } catch (error) {
      console.error("Error While updating conversation", error);
      dispatch(getUpdatedConversationFailure(error.message || "Unknown Error"));
    }
  };

  return {
    renameConversation,
    fetchAllConversations,
    sendNovaChatFeedback,
    getUpdatedConversation,
  };
};

export default useNovaApi;
